module.exports = "<div class=branding-screen__contents> <img ng-src={{$ctrl.AppServices.DataManager.config.settings.assetsPath}}branding-screen/ad_001.png hm-tap=$ctrl.openLink($ctrl.options.assets[0].link)> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/branding-screen/branding-screen.html
 ** module id = 74
 ** module chunks = 0
 **/